import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import qs from 'qs';
import { rewriteAlertBanners, submitNewPassword } from '../../actions';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AuthShell from './AuthShell';
import styles from './AuthShell.module.scss';

const PasswordReset = ({ location }) => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { settings, auth } = useSelector((store) => store, undefined);
  const { loader } = auth;
  const { alerts } = settings;
  const { actions } = alerts;

  const parseOptions = { ignoreQueryPrefix: true };

  //todo change it to get from useLocation or useMatch, not this shit
  const queryString = qs.parse(location.search, parseOptions);
  const { token } = queryString;

  const newPasswordRef = useRef(null);
  const repeatNewPasswordRef = useRef(null);

  const submitHandler = (event) => {
    if (event) event.preventDefault();
    const newPassword = newPasswordRef.current.value;
    const repeatNewPassword = repeatNewPasswordRef.current.value;

    // todo: better validation
    if (!token) {
      dispatch(rewriteAlertBanners([actions.PASSWORD_SUBMIT_TOKEN_NOT_FOUND]));
      return;
    }

    if (newPassword !== repeatNewPassword) {
      dispatch(rewriteAlertBanners([actions.PASSWORDS_NOT_MATCHED]));
      return;
    }

    if (newPassword.length < 8) {
      dispatch(rewriteAlertBanners([actions.PASSWORD_TOO_SHORT]));
      return;
    }

    dispatch(submitNewPassword({
      password: newPasswordRef.current.value,
      token,
    }));
  };

  return (
    <>
      <AuthShell
        title={localizeMessage('auth.change.title')}
        description={localizeMessage('auth.change.description')}
        loading={loader}
      >
        <form className={styles.form} onSubmit={submitHandler}>
          <TextField
            id="kea-new-password"
            className={styles.field}
            type="password"
            label={localizeMessage('appModule.enterNewPassword')}
            autoComplete="new-password"
            fullWidth
            required
            variant="outlined"
            inputRef={newPasswordRef}
            disabled={loader}
          />
          <TextField
            id="kea-repeat-new-password"
            className={styles.field}
            type="password"
            label={localizeMessage('appModule.repeatNewPassword')}
            autoComplete="new-password"
            fullWidth
            required
            variant="outlined"
            inputRef={repeatNewPasswordRef}
            disabled={loader}
          />
          <Button
            className={styles.primaryButton}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loader}
          >
            <IntlMessages id="appModule.updatePassword" />
          </Button>
        </form>
      </AuthShell>
    </>
  );
};

PasswordReset.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }).isRequired,
};

export default PasswordReset;
